var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagicWand01 = function SvgMagicWand01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.467 7.561 5.823 4.917l1.07-1.069 2.644 2.644zm3.783-2.269v-3.75h1.5v3.75zm6.833 12.885-2.644-2.644 1.069-1.07 2.644 2.645zM17.7 7.369 16.631 6.3l2.644-2.644 1.07 1.069zm1.008 4.381v-1.5h3.75v1.5zM5.144 21.104l-2.257-2.258a.87.87 0 0 1-.271-.633q0-.36.27-.632l8.797-8.812a2.4 2.4 0 0 1 1.768-.73q1.04 0 1.77.728.732.728.731 1.77 0 1.04-.73 1.77L6.41 21.105a.87.87 0 0 1-.633.271.87.87 0 0 1-.633-.271m.633-1.465 6.275-6.275-1.425-1.4-6.25 6.25z"
  })));
};
export default SvgMagicWand01;